import { store } from 'react-easy-state'

const _store = store({
  referenceCode: '',

  setReOtp(referenceCode) {
    _store.referenceCode = referenceCode
  }
})

export default _store
